/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/prod_1': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M28 19.354L31.354 16 28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646zM30.646 16L28 18.646v-5.293L30.646 16zM16 1.354L18.646 4h-5.293L16 1.354zM1.354 16L4 13.354v5.292L1.354 16zM16 30.646L13.354 28h5.292L16 30.646zM26 26H6V6h20v20z"/><path pid="1" d="M16.323 15.27a2.99 2.99 0 002.121-.879l6.568-6.545L25.001 7h-7.5l-3.299 3.148a2.998 2.998 0 000 4.242c.586.587 1.354.88 2.121.88zm-.312-3.688a1 1 0 110 2 1 1 0 010-2zM18.012 17.92l-.337-.338H17.012v-1.82c-.61.188-1.5.107-2-.08v1.9h-.647l-.354.354-1.646 1.646a.5.5 0 000 .708l1.592 1.59.707-.707-1.238-1.236 1.352-1.352h2.479l1.341 1.352-1.23 1.238.711.705 1.578-1.592a.502.502 0 000-.705l-1.645-1.663z"/>'
  }
})
